
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 22.5C1 10.645 10.645 1 22.499 1 34.355 1 44 10.645 44 22.5S34.355 44 22.499 44C10.645 44 1 34.355 1 22.5zM22.499 3C11.749 3 3 11.75 3 22.5S11.75 42 22.499 42C33.251 42 42 33.25 42 22.5S33.25 3 22.499 3zm.262 23.678h-.79c0-2.36.283-3.927.849-4.698.565-.77 1.121-1.526 1.668-2.268.858-1.307 1.288-2.663 1.288-4.068 0-1.132-.322-2.049-.966-2.751-.644-.703-1.444-1.054-2.4-1.054-.8 0-1.473.2-2.02.6-.546.4-.82.815-.82 1.244 0 .176.079.332.235.468.156.137.263.234.322.293.175.195.36.38.556.556.195.254.293.566.293.937 0 .448-.142.834-.425 1.156-.283.322-.668.483-1.156.483-.546 0-1.01-.23-1.39-.688-.38-.459-.57-1.03-.57-1.712 0-1.132.521-2.147 1.565-3.044 1.044-.898 2.337-1.347 3.878-1.347 1.6 0 2.932.493 3.995 1.478 1.064.986 1.595 2.21 1.595 3.674 0 .936-.16 1.736-.483 2.4-.322.663-.824 1.297-1.507 1.902-1.444 1.288-2.263 2.039-2.458 2.254-.84.936-1.259 2.331-1.259 4.185zm-.38 3.132c.487 0 .907.175 1.258.527.351.35.527.77.527 1.258s-.17.912-.512 1.273a1.681 1.681 0 01-1.274.542c-.507 0-.926-.176-1.258-.527a1.806 1.806 0 01-.498-1.288c0-.488.176-.907.527-1.258.351-.352.761-.527 1.23-.527z"}})])
          )
        }
      }
    